import React from 'react';
import "./NotFound.css";
const NotFound = () => {
  return (
    <div>
      <h2 className="margin-top-40">404 Not Found</h2>
      <p className="center-text">Sorry, the page you are looking for does not exist.</p>
    </div>
  );
};

export default NotFound;